export default {
	name: "人民币",
	code: "CNY",
	symbol: "￥",
	setSymbol(symbol) {
		this.symbol = symbol;
	}
}
